module.exports = __webpack_public_path__ + "static/10-cdf3a191f9a4b8d31d52d6243e2c86b5.jpg";